import {isEmpty, throttle} from "lodash"
import {applyMiddleware, createStore} from "redux"
import {thunk} from "redux-thunk"

import {composeWithDevTools} from "@redux-devtools/extension"

import HomePageEbu from "../constants/homepageEbu"
import * as localStorage from "../services/localStorage"
import * as sessionStorage from "../services/sessionStorage"

    /**
 * Create a store from all reducers, add the thunk and logger middlewares.
 * Fill the store with local storage content if necessary.
 * Configure a function to save the store in the local storage every second if necessary.
 * @returns {Store<S>} the configured store
 */
const configureStore = reducers => {
    const path = window.location.pathname
    const isCesu = path.includes(HomePageEbu.CESU)
    const isSap = path.includes(HomePageEbu.SAP)

    const middlewares = [thunk]

    // Récupération du state existant dans le localStorage et le sessionStorage
    const existingState = localStorage.loadState()
    const existingSession = sessionStorage.loadState()

    // Initliation du state avec le le localStorage et le sessionStorage existant
    const state = {
        localStorage: existingState || {},
        sessionStorage: existingSession || {},
    }

    const store = createStore(reducers, state, composeWithDevTools(applyMiddleware(...middlewares)))

    // Save to localStorage only when there are actual changes
    let previousState = state
    store.subscribe(
        throttle(() => {
            const currentState = store.getState()
            let hasChanged = false

            // On vérifie que les données du local storage ont changé
            // Pour l'EBU, quand on arrive coté CESU ou coté SAP, il faut garder les données du local storage existant
            // Pour les autres applications, on garde le même fonctionnement
            if (JSON.stringify(currentState.localStorage) !== JSON.stringify(previousState.localStorage)) {
                if (!isEmpty(existingState?.cesu) && isSap) {
                    currentState.localStorage.cesu = existingState.cesu
                }
                if (!isEmpty(existingState?.sap) && isCesu) {
                    currentState.localStorage.sap = existingState.sap
                }
                localStorage.saveState(currentState.localStorage)
                hasChanged = true
            }
            // On vérifie que les données du session storage ont changé
            if (JSON.stringify(currentState.sessionStorage) !== JSON.stringify(previousState.sessionStorage)) {
                sessionStorage.saveState(currentState.sessionStorage)
                hasChanged = true
            }
            // On met à jour le state si il y a eu des changements
            if (hasChanged) {
                previousState = currentState
            }
        }, 1000),
    )

    return store
}

export default configureStore
